<template>
  <div class="content">
    <el-row type="flex">
      <el-col :span="12">
        <el-form
          label-position="top"
          label-width="80px"
          :rules="rules"
          ref="form"
          :model="form"
        >
          <el-form-item label="中文公告概述" prop="lang_list[1].title">
            <el-input
              v-model="form.lang_list[1].title"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="繁体公告概述" prop="lang_list[2].title">
            <el-input
              v-model="form.lang_list[2].title"
              placeholder="请输入"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="英文公告概述" prop="lang_list[0].title">
            <el-input
              v-model="form.lang_list[0].title"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="公告类型" prop="type">
            <el-select
              v-model="form.type"
              placeholder="请选择"
              style="width: 250px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="报名截止时间"
            prop="end_at"
            v-if="form.type == 'activity_notice'"
          >
            <el-date-picker
              style="width: 250px"
              v-model="form.end_at"
              format="yyyy 年 MM 月 dd 日 HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="发放积分"
            prop="reward_value"
            v-if="form.type == 'activity_notice'"
          >
            <el-input
              v-model="form.reward_value"
              placeholder="请输入"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item label="发布时间" prop="publish_at">
            <el-date-picker
              style="width: 250px"
              format="yyyy 年 MM 月 dd 日 HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              v-model="form.publish_at"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="发布人群" prop="publish_type">
            <el-select
              v-model="form.publish_type"
              placeholder="请选择"
              style="width: 250px"
            >
              <el-option
                v-for="item in publish_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="whitelist"
            v-if="form.publish_type == 'whitelist'"
          >
            <el-input
              type="textarea"
              v-model="form.whitelist"
              placeholder="请输入接收人ID，以英文,号隔开"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传文件">
            <!-- {{ form.files }} -->
            <UploadDoc
              v-model="form.files"
              @uploaddoc="uploaddoc"
              ref="uploadDoc"
            ></UploadDoc>
          </el-form-item>

          <el-form-item label="中文公告详情" prop="lang_list[1].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[1].content"
              :value="form.lang_list[1].content"
              ref="tinymce"
            />
          </el-form-item>
          <!-- <el-form-item label="繁体公告详情" prop="lang_list[2].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[2].content"
              :value="form.lang_list[2].content"
              ref="tinymce"
            />
          </el-form-item> -->
          <el-form-item label="英文文公告详情" prop="lang_list[0].content">
            <tinymce
              :height="400"
              v-model="form.lang_list[0].content"
              :value="form.lang_list[0].content"
              ref="tinymce"
            />
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回 </el-button>
              <el-button type="primary" @click="store" :loading="btnLoading"
                >提交</el-button
              >
            </el-row>
          </el-form-item>
        </el-form></el-col
      >
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import Tinymce from '@/components/Tinymce'
import UploadDoc from '@/components/UploadDoc/index.vue'
export default {
  components: { Tinymce, UploadDoc },
  data() {
    return {
      options: [
        // {
        //   value: 'system_message',
        //   label: '系统消息',
        // },
        {
          value: 'system_notice',
          label: '系统公告',
        },
        {
          value: 'activity_notice',
          label: '活动公告',
        },
      ],
      publish_options: [
        {
          value: 'whitelist',
          label: '特定人群',
        },
        {
          value: 'all_user',
          label: '全部用户',
        },
        {
          value: 'all_vip',
          label: '全部会员',
        },
      ],
      rules: {
        'lang_list[0].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[1].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[2].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        type: [
          {
            required: true,
            message: '请选择公告类型',
            trigger: 'change',
          },
        ],
        end_at: [
          {
            required: true,
            message: '请选择报名截止时间',
            trigger: 'change',
          },
        ],
        publish_at: [
          {
            required: true,
            message: '请选择发布时间',
            trigger: 'change',
          },
        ],
        reward_value: [
          {
            required: true,
            message: '请输入奖励数量',
            trigger: 'change',
          },
        ],
        publish_type: [
          {
            required: true,
            message: '请选择发布人群',
            trigger: 'change',
          },
        ],
        whitelist: [
          {
            required: true,
            message: '请输入接收人',
            trigger: 'change',
          },
        ],
        'lang_list[0].content': [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change',
          },
        ],
        'lang_list[1].content': [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change',
          },
        ],
        'lang_list[2].content': [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'change',
          },
        ],
      },
      btnLoading: false,
      form: {
        id: '',
        type: '',
        publish_at: '',
        end_at: '',
        reward_value: '',
        publish_type: '',
        whitelist: '',
        lang_list: [
          {
            lang: 'en_US',
            title: '',
            content: '',
          },
          {
            lang: 'zh-CN',
            title: '',
            content: '',
          },
          // {
          //   lang: 'zh-TW',
          //   title: '',
          //   content: '',
          // },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.detail()
    }
  },
  methods: {
    uploaddoc(res) {
      console.log('uploaddoc', res)
    },
    back() {
      this.$router.back()
    },
    processFileUrls(fileList) {
      // 定义需要检查和移除的基础路径
      const basePath = process.env.VUE_APP_AWS_S3_DOMAIN
      // 遍历文件列表并处理每个元素
      return fileList.map((file) => {
        // 检查文件对象是否存在且包含 url 属性
        if (file && file.url) {
          // 判断 url 是否包含指定的基础路径
          if (file.url.includes(basePath)) {
            // 移除基础路径，只保留后面的部分
            const processedUrl = file.url.replace(basePath, '')
            // 返回更新后的对象（不修改原对象）
            return {
              ...file,
              url: processedUrl,
            }
          }
        }
        // 如果不包含指定路径或对象无效，返回原对象
        return file
      })
    },
    async store() {
      await this.$refs.uploadDoc.handleSubmit()
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          let imgPrefix = process.env.VUE_APP_AWS_S3_DOMAIN
          let prefixRegex = new RegExp(`^${imgPrefix}`)
          if (this.form.files?.length > 0) {
            this.form.files = this.processFileUrls(this.form.files)
          }
          if (this.form.lang_list) {
            this.form.lang_list = this.form.lang_list.map((item) => {
              // 检查content中是否包含img标签
              if (item.content.includes('<img')) {
                // 使用正则表达式匹配所有img标签的src属性，并添加前缀
                const updatedContent = item.content.replace(
                  /<img([^>]*?)src="([^"]*?)"/g,
                  (match, attrs, src) => {
                    // 检查src是否已包含前缀
                    if (prefixRegex.test(src)) {
                      // 已包含前缀，移除
                      const newSrc = src.replace(prefixRegex, '')
                      return `<img${attrs}src="${newSrc}"`
                    }
                  },
                )

                // 返回更新后的对象
                return {
                  ...item,
                  content: updatedContent,
                }
              }

              // 如果没有img标签，直接返回原对象
              return item
            })
            console.log(this.form.lang_list)
          }
          request({
            url: '/api/backend/message/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/bulletin/System',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    detail() {
      request({
        url: '/api/backend/message/detail',
        method: 'get',
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            ...res.data,
            files: res.data.files || [],
          }
          let imgPrefix = process.env.VUE_APP_AWS_S3_DOMAIN
          // if(this.form.files.length>0){
          //   this.form.files=this.form.files.map((item) => {

          //     // 如果没有img标签，直接返回原对象
          //     return item
          //   })
          // }
          if (this.form.lang_list) {
            this.form.lang_list = this.form.lang_list.map((item) => {
              // 检查content中是否包含img标签
              if (item.content.includes('<img')) {
                // 使用正则表达式匹配所有img标签的src属性，并添加前缀
                const updatedContent = item.content.replace(
                  /<img([^>]*?)src="([^"]*?)"/g,
                  `<img$1src="${imgPrefix}$2"`,
                )

                // 返回更新后的对象
                return {
                  ...item,
                  content: updatedContent,
                }
              }

              // 如果没有img标签，直接返回原对象
              return item
            })
            console.log(this.form.lang_list)
          }
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
  overflow: scroll;
}
</style>
